/**
 * API configuration for DXLiving backend
 * Base URL can be overridden via VITE_API_BASE_URL in .env
 */
// In dev, use relative path so Vite proxy handles CORS; in prod, use full URL
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? '' : 'https://stage-api.dxinteriors.ai');

/** Empty in dev so task resolver WS uses same origin + Vite proxy (see getWsUrl). Override with VITE_WS_BASE_URL. */
export const WS_BASE_URL =
  import.meta.env.VITE_WS_BASE_URL ||
  (import.meta.env.DEV ? '' : 'wss://stage-api.dxinteriors.ai');

export const AUTH_ENDPOINTS = {
  login: '/api/v1/auth/login',
  logout: '/api/v1/auth/logout',
  refresh: '/api/v1/auth/token/refresh',
};

export const USER_ENDPOINTS = {
  me: '/api/v1/users/me',
};

export const ROOM_ENDPOINTS = {
  create: '/api/v1/rooms/',
  getRoom: (roomId) => `/api/v1/rooms/${roomId}`,
  uploadImage: (roomId) => `/api/v1/rooms/${roomId}/images`,
  uploadChildImage: (roomId, parentRoomImageId) =>
    `/api/v1/rooms/${roomId}/images/${parentRoomImageId}`,
  objects: (roomId) => `/api/v1/rooms/${roomId}/objects`,
  interiors: (roomId, imageId) => `/api/v1/rooms/${roomId}/images/${imageId}/interiors`,
  interiorDelete: (roomId, imageId, interiorId) => `/api/v1/rooms/${roomId}/images/${imageId}/interiors/${interiorId}`,
  interiorRestore: (roomId, imageId, interiorId) => `/api/v1/rooms/${roomId}/images/${imageId}/interiors/${interiorId}/restore`,
  renderHistory: (roomId, imageId) => `/api/v1/rooms/${roomId}/images/${imageId}/render-history`,
  renderHistoryEntry: (roomId, imageId, renderHistoryId) =>
    `/api/v1/rooms/${roomId}/images/${imageId}/render-history/${renderHistoryId}`,
};

export const AI_INFERENCE_ENDPOINTS = {
  run: '/api/v1/ai-inference/',
  getResult: (taskId) => `/api/v1/ai-inference/${taskId}`,
  cancel: (taskId) => `/api/v1/ai-inference/${taskId}/cancel`,
  getPresignedUrl: (objectName) =>
    `/api/v1/ai-inference/presigned-url?object-name=${encodeURIComponent(objectName)}`,
};

export const SUPPLIER_INTERIORS_ENDPOINTS = {
  /** GET /api/v1/supplier-interiors/interior-types - all top-level interior types (parentId: null) */
  interiorTypesList: '/api/v1/supplier-interiors/interior-types',
  /** GET /api/v1/supplier-interiors/interior-types/{parentId} - children of a parent */
  interiorTypes: (parentId) => `/api/v1/supplier-interiors/interior-types/${parentId}`,
  /** POST /api/v1/supplier-interiors/materials */
  materials: '/api/v1/supplier-interiors/materials',
  /** POST /api/v1/supplier-interiors/ - create product */
  products: '/api/v1/supplier-interiors/',
  /** DELETE /api/v1/supplier-interiors/{interiorId} - remove a supplier product / interior */
  interiorById: (interiorId) => `/api/v1/supplier-interiors/${encodeURIComponent(String(interiorId))}`,
};

export const TASK_RESOLVER_CONFIG = {
  pollIntervalMs: 2000,
  wsEnabled: true,
  wsBaseUrl: WS_BASE_URL,
  wsPath: '/api/v1/ws',
  getAccessToken: () => null,
  max5xxRetries: 5,  // after this many 5xx in a row, treat task as failed
};
